module.exports = __webpack_public_path__ + "img/new_notes.82cbf572.svg";